<div class="footer bg-primary">
  <div class="footer-image">
    <img class="footer-logo" [src]="'images/footer/footer-logo.png' | contentAssetImage" draggable="false" />
  </div>
  <div>
    <div class="text-white font-size-14 text-center">{{ 'footer.copyright' | translate }}</div>
    <div class="text-white font-size-14 text-center">{{ 'footer.copyright2' | translate }}</div>
  </div>
</div>
